/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect, useContext } from 'react';
import { translate } from 'gatsby-core-theme/src/helpers/getters';
import Button from 'gatsby-core-theme/src/components/atoms/button';
import { setCookie, getCookie } from 'gatsby-core-theme/src/helpers/cookies';
import { navigate } from 'gatsby-link';
import { Context } from '~context/TranslationsProvider';

import styles from './cookies-page-content.module.scss';

const CookiesPageContent = () => {
  const { translations } = useContext(Context) || {};
  const [option, setOption] = useState('option_1');

  // when component did mount
  useEffect(() => {
    const getCk = getCookie('CookieConsent') || false;
    setOption(getCk === 'true' ? 'option_2' : 'option_1');
  }, []);

  const handleAccept = () => {
    if (!option) return;
    const status = option && option === 'option_2';
    setCookie('CookieConsent', status, 365, '/');
    navigate(`/`);
  };

  return (
    <div className={styles.container}>
      <div className={styles.options}>
        <div>
          <input
            type="radio"
            id="required_cookies"
            value="option_1"
            checked={option === 'option_1'}
            onChange={(e) => setOption(e.target.value)}
          />
          <label htmlFor="required_cookies">
            <h4>{translate(translations, 'required_cookies', 'Required Cookies')}</h4>
          </label>
        </div>
        <p>
          {translate(
            translations,
            'required_cookies_text',
            'These cookies are required to enable core site functionality, specifically make sure the website looks consistent.'
          )}
        </p>
      </div>
      <div className={styles.options}>
        <div>
          <input
            type="radio"
            id="functional_advertising_cookies"
            value="option_2"
            checked={option === 'option_2'}
            onChange={(e) => setOption(e.target.value)}
          />
          <label htmlFor="functional_advertising_cookies">
            <h4>
              {translate(
                translations,
                'functional_advertising_cookies',
                'Functional and Advertising Cookies'
              )}
            </h4>
          </label>
        </div>
        <p>
          {translate(
            translations,
            'functional_advertising_cookies_text',
            'These cookies allow us to analyze site usage so we can measure and improve performance.'
          )}
        </p>
      </div>
      <div className={styles.button}>
        <Button
          onClick={() => handleAccept()}
          btnText={translate(translations, 'i_agree', 'I Agree')}
          isInternalLink={false}
          isButton
          primaryColor={false}
          tertiary
          gtmClass="cookie-consent-gtm btn-cta"
        />
      </div>
    </div>
  );
};

export default CookiesPageContent;
